import React from "react";

export const Label = ({ children }) => (
  <label className="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-600">
    {children}
  </label>
);

export const Input = ({ className = "", ...rest }) => (
  <input
    {...rest}
    className={
      "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2 " +
      className
    }
  />
);

export const Select = ({ className = "", children, ...rest }) => (
  <select
    {...rest}
    className={
      "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2 " +
      className
    }
  >
    {children}
  </select>
);
